"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../schema");
const weight = schema_1.Schema.number()
    .unit("kg")
    .precision(2)
    .max(999)
    .minExclusive(0)
    .interpretation({ vocab: "basic_health", code: "weight" })
    .tag({ vocab: "snomed", code: "363808001" })
    .tag({ vocab: "loinc", code: "29463-7" })
    .tag({ vocab: "srtr", code: "can_most_recent_wgt_kg7" });
const height = schema_1.Schema.number()
    .unit("cm")
    .integer()
    .max(999)
    .minExclusive(0)
    .interpretation({ vocab: "basic_health", code: "height" })
    .tag({ vocab: "snomed", code: "50373000" })
    .tag({ vocab: "loinc", code: "8302-2" })
    .tag({ vocab: "srtr", code: "can_hgt_cm" });
const bmi = schema_1.Schema.expression(`toPrecision({../weight} / ({../height} / 100) ** 2, 1)`)
    .unit("kg/m2")
    .interpretation({ vocab: "basic_health", code: "bmi" })
    .tag({ vocab: "snomed", code: "60621009" })
    .tag({ vocab: "loinc", code: "39156-5" });
const dubois = schema_1.Schema.expression(`toPrecision(0.007184 * {../../weight} ** 0.425 * {../../height} ** 0.725, 1)`).unit("m2");
const monsteller = schema_1.Schema.expression(`toPrecision(0.016667 * {../../weight} ** 0.5 * {../../height} ** 0.5, 1)`).unit("m2");
const bsa = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ dubois, monsteller })
    .interpretation({ vocab: "basic_health", code: "bsa" })
    .tag({ vocab: "snomed", code: "128178001" })
    .tag({ vocab: "loinc", code: "3140-1" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ weight, height, bmi, bsa })
    .tag({ vocab: "snomed", code: "248326004" })
    .tag({ vocab: "loinc", code: "5418-8" });
